export const DND_ACCEPT_TYPES = {
    DROP_OPTION: 'drop-option',
    DROP_QUESTION: 'drag-option',
    DRAG_OPTION: 'drag-option',
    DRAG_QUESTION: 'drop-option',
};
